import React, { Fragment, useState } from 'react';

import ArchivedDetails from '../archived_details/archived_details';
import RoleDetails from '../role_components/role_details';
import TraineeModal from '../modals/trainee_modal'
import TeamDetails from '../team_details';

import './matrix_trainee_details.css'


export default function MatrixTraineeDetails (props) {
  const { trainee, disabled, updateTraineeDetails } = props;
  const [ editFormShown, setEditFormShown ] = useState(false)

  const showEditForm = (evt) => {
    if (disabled) return;
    setEditFormShown(true)
  }

  const closeEditForm = () => {
    setEditFormShown(false)
  }

  const updateTrainee = (details) => {
    closeEditForm()
    updateTraineeDetails(details)
  }

  return (
    <Fragment>
      <div onClick={showEditForm} className='matrix-trainee-details'>
        {trainee.fullname}
        {
          trainee.email &&
          <div className='matrix-trainee-email'>({trainee.email})</div>
        }
        {
          trainee.archived &&
          <ArchivedDetails archivedDate={trainee.archived_date} /> 
        }
        {
          trainee.role_list && trainee.role_list.length > 0 &&
          <RoleDetails roleList={trainee.role_list} />
        }
        {
          trainee.role_list && trainee.tag_list.length > 0 &&
          <TeamDetails teamList={trainee.tag_list} />
        }
      </div>
      {
        editFormShown &&
        <TraineeModal
          selectedTrainee={trainee}
          updateTrainee={ updateTrainee }
          onClose={ closeEditForm }
        />
      }
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/trainee_details/matrix_trainee_details.js